import { conferirMunicipios } from "./conferenciaMunicipios";

function valorPositivo(valor) {
  if (typeof valor === "number") return Number.isFinite(valor) && valor > 0;
  const texto = String(valor || "").trim();
  const numero = Number(texto.includes(",") ? texto.replace(/\./g, "").replace(",", ".") : texto);
  return Number.isFinite(numero) && numero > 0;
}

function dataUtc(valor) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(valor || "")) return null;
  const data = new Date(valor + "T00:00:00Z");
  return Number.isFinite(data.getTime()) && data.toISOString().slice(0, 10) === valor ? data : null;
}

// Limite superior: feriados so podem reduzir a quantidade de dias uteis.
// Inclui a data da ida e exclui a solicitacao; nao certifica o prazo normativo.
function diasSemanaAteIda(solicitacao, ida) {
  const inicio = dataUtc(solicitacao);
  const fim = dataUtc(ida);
  if (!inicio || !fim || fim < inicio) return null;
  const dias = Math.round((fim - inicio) / 86400000);
  let quantidade = Math.floor(dias / 7) * 5;
  for (let i = 1; i <= dias % 7; i += 1) {
    const dia = (inicio.getUTCDay() + i) % 7;
    if (dia !== 0 && dia !== 6) quantidade += 1;
  }
  return quantidade;
}

export function orientacoesViagem(dados = {}, contexto = {}) {
  const avisos = [];
  const internacional = String(dados.tipoDiaria || "").startsWith("Internacional");
  const adicionar = (id, titulo, texto, base, etapas, atencao = false, fonte = "") => {
    avisos.push({ id, titulo, texto, base, etapas, atencao, fonte });
  };

  adicionar("condicoes", "Condições para receber diárias",
    "Confira se não há férias, licença ou suspensão do contrato, nem pendências de prestação de contas de viagens anteriores. A viagem deve ter interesse institucional.",
    "Arts. 2, 27 e 30", [0, 6]);

  if (dados.tipoDiaria) {
    const minimo = internacional ? 15 : 5;
    const diasSemana = diasSemanaAteIda(dados.dataSolicitacao, dados.dataIda);
    const curto = diasSemana !== null && diasSemana < minimo;
    const intervalo = curto
      ? ` O intervalo informado tem no máximo ${diasSemana} dia(s) de segunda a sexta até a ida, antes de descontar feriados. Confira o prazo com a área responsável.`
      : "";
    adicionar("antecedencia", curto ? "Conferir antecedência: prazo curto" : "Antecedência da solicitação",
      `Solicite com antecedência de ${minimo} dias úteis para viagem ${internacional ? "internacional" : "nacional"}. Confira os feriados nacionais, estaduais e municipais no calendário institucional.` + intervalo,
      "Art. 11", [1, 2, 6], curto);
  } else {
    adicionar("antecedencia", "Antecedência da solicitação",
      "Solicite com antecedência de 5 dias úteis para viagem nacional e 15 dias úteis para internacional. Confira os feriados nacionais, estaduais e municipais no calendário institucional.",
      "Art. 11", [1, 6]);
  }

  if (dados.destino && !internacional) {
    const conferencia = conferirMunicipios(contexto.sedeMunicipioCodigo, dados.destino, dados.tipoDiaria);
    const orientarZero = ["MESMO_MUNICIPIO", "LIMITROFE"].includes(conferencia.situacao);
    const textos = {
      MESMO_MUNICIPIO: `${conferencia.destino} é o mesmo município da sede de trabalho. O art. 22 veda a concessão de diária nessa situação. Confira o enquadramento com os aprovadores.`,
      LIMITROFE: `${conferencia.destino} é limítrofe à sede de trabalho em ${conferencia.sede}. O art. 22 veda a concessão de diária nessa situação. Confira o enquadramento com os aprovadores.`,
      NAO_LIMITROFE: `${conferencia.destino} é diferente e não limítrofe à sede de trabalho em ${conferencia.sede}. Não há impedimento territorial identificado pelo art. 22 para esse par de municípios. As demais condições da viagem continuam aplicáveis.`,
      INCONCLUSIVO: "Confirme a sede de trabalho e informe o município de destino com UF, por exemplo Petrópolis/RJ. A base consultada permite conferir sedes no RJ e seus vizinhos; locais não identificados exigem conferência manual. Não é possível concluir o enquadramento territorial com os dados atuais.",
    };
    const instrucao = orientarZero
      ? ' Marque “Faz jus ao pagamento de diária na data de ida?” como Não e zere manualmente os campos Quant. Diárias e Quant. ½ Diárias. Confira se o Total de Diárias ficou em R$ 0,00. Km e outros adiantamentos precisam de análise própria.'
      : "";
    adicionar("municipio", orientarZero ? "Atenção: diária não devida pelo art. 22" : "Conferência do município de destino",
      textos[conferencia.situacao] + instrucao, "Art. 22", orientarZero ? [1, 2, 4, 6] : [1, 6], conferencia.situacao !== "NAO_LIMITROFE", conferencia.fonte);
  }

  if (dados.modalidade === "Veículo Próprio") {
    adicionar("veiculo-proprio", "Documentos para veículo próprio",
      "Providencie autorização, comprovação de habilitação, seguro exigido, estimativa de Km pelo Google Maps e Termo de Uso de Carro Próprio. A autorização deve observar a disponibilidade de veículo locado.",
      "Art. 18", [3, 6]);
  }

  const despesas = [];
  if (valorPositivo(dados.vlHospedagem)) despesas.push("hospedagem");
  if (valorPositivo(dados.vlAlimentacao)) despesas.push("alimentação");
  if (valorPositivo(dados.totalDiarias) && despesas.length) {
    adicionar("despesas-cobertas", "Conferência de despesas já cobertas",
      `Há diária e adiantamento de ${despesas.join(" e ")}. Confira se essas despesas já estão cobertas pela diária ou por contratação direta, para evitar duplicidade de custeio.`,
      "Arts. 5, 14 e 15", [3, 4, 6], true);
  }

  if (internacional) {
    const misturaMoedas = ["totalAdiantamento", "vlTranslado", "vlAlimentacao", "vlHospedagem", "totalKm", "devolucao", "demaisdespesas"]
      .some(campo => valorPositivo(dados[campo]));
    adicionar("moeda", "Pagamento de diária internacional",
      "A diária em dólar ou euro será paga em reais, pelo câmbio turismo do dia do pagamento." +
      (misturaMoedas ? " Há também valores informados em R$. Solicite ao Financeiro a conciliação entre as moedas antes de considerar um total consolidado." : " Confira a conversão com o Financeiro antes do pagamento."),
      "Art. 25", [2, 4, 6], misturaMoedas);
  }

  adicionar("prestacao", "Prestação de contas após o retorno",
    "Apresente o relatório e a prestação de contas em até 10 dias úteis após o retorno, com os comprovantes de hospedagem e demais despesas aplicáveis." +
    (dados.modalidade === "Aéreo" ? " Inclua os cartões de embarque." : "") +
    " Confirme o relatório aplicável à sua área e considere os feriados na contagem do prazo.",
    "Art. 26", [6]);

  return avisos;
}
